<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Book Description</span></p>
<p class="P_WFP_BodyText">Keith Doyle and Holl, one of the Little Folk, set off on an educational tour to find their roots. Keith knows his family comes from the south of Ireland, but Holl’s people lost contact with their relatives long ago. On a tour of archaeological digs, Keith recklessly falls prey not only to local smugglers, but magical beings who are far less friendly than the ones back home. Holl, who needs to secure a rare flower to permit him to marry his beloved, Maura, has no choice but to summon the Master, head of his village, and Diane, Keith’s girlfriend. Together, they must rescue Keith from his own folly and solve the mystery of the disappearance of the Little Folk….</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?276822cb